import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductSetupService {
  productHierarchyMinimumLevel: number = 2;
  productHierarchyMaximumLevel: number = 10;

  constructor(private http: HttpClient) { }

  GetProductHierarchyList(): Observable<any> {
    return this.http.get<any>(`${environment.HierarchyManager}/productHierarchyMetadataGetList`,)
      .pipe(map(response => {
        return response;
      }));
  }

  GetHierarchyNodeMetadataList(): Observable<any> {
    return this.http.get<any>(`${environment.HierarchyManager}/productHierarchyNodeMetadataGetList`,)
      .pipe(map(response => {
        return response;
      }));
  }

  UpdateProductHierarchyLIst(body): Observable<any> {
    return this.http.post<any>(`${environment.HierarchyManager}/productHierarchyInsertOrUpdateMetadataItems`, body)
      .pipe(map(response => {
        return response;
      }));
  }

}
